import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Component Imports
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import Products from './pages/Products';
import Services from './pages/Services';
import Industries from './pages/Industries';
import Solutions from './pages/Solutions';
import Technologies from './pages/Technologies';
import RequestDemo from './pages/RequestDemo';
import ScrollToTop from "./ScrollToTop";
import Blog from './pages/Blog';
import TermsConditions from './pages/TermsConditions';


//Product Page Imports
import EducationERP from './pages/Products/Educationerp'; 
import HospitalERP from './pages/Products/Hospitalerp';
import Inventoryerp from './pages/Products/Inventoryerp';
import HRMS from './pages/Products/HRMS';
import CRM from './pages/Products/CRM';
import Customerp from './pages/Products/Customerp';
import FinanceERP from './pages/Products/Financeerp';
import ManufacturingERP from './pages/Products/Manufacturingerp';
import RetailPOS from './pages/Products/Retailpos';
import LogisticsERP from './pages/Products/Logisticserp';
import FoodERP from './pages/Products/Fooderp';
import Hotelmanagement from './pages/Products/Hotelmanagement';

// Services page imports
import DigitalTransformation from './pages/Services/DigitalTransformation';
import AiAutomation from './pages/Services/AiAutomation';
import ApiDevelopment from './pages/Services/ApiDevelopment';
import CloudSolutions from './pages/Services/CloudSolutions';
import SoftwareDevelopment from './pages/Services/SoftwareDevelopment';
import WebDevelopment from './pages/Services/WebDevelopment';
import MobileAppDevelopment from './pages/Services/MobileAppDevelopment';
import UiUxDesign from './pages/Services/UiUxDesign';

// Solutions page imports
import BusinessOperations from './pages/Solutions/BusinessOperations';
import ManagementSystems from './pages/Solutions/ManagementSystems';
import CustomerEngagement from './pages/Solutions/CustomerEngagement';
import AiAutomationsolutions from './pages/Solutions/AiAutomationsolutions';

// Industries page imports
import Automotive from './pages/Industries/Automotive';
import Construction from './pages/Industries/Construction';
import Pharmaceutical from './pages/Industries/Pharmaceutical';
import RealEstate from './pages/Industries/RealEstate';
import EnergyUtilities from './pages/Industries/EnergyUtilities';
import MediaEntertainment from './pages/Industries/MediaEntertainment';
import Agriculture from './pages/Industries/Agriculture';
import Government from './pages/Industries/Government';
import Ngo from './pages/Industries/Ngo';
import FoodProcessing from './pages/Industries/FoodProcessing';
import Insurance from './pages/Industries/Insurance';
import Hospitality from './pages/Industries/Hospitality';
import Finance from './pages/Industries/Finance';
import Education from './pages/Industries/Education';
import Healthcare from './pages/Industries/Healthcare';
import Manufacturing from './pages/Industries/Manufacturing';
import Retail from './pages/Industries/Retail'; 
import Logistics from './pages/Industries/Logistics';

// import Other ways to reach out to us
// import Feedback from './pages/Feedback';
// import SupportTicket from './pages/SupportTicket';
// import LiveChat from './pages/LiveChat';
// import HelpCenter from './pages/HelpCenter';

function App() {
  return (
    <Router>
      <ScrollToTop />

      <div className="min-h-screen w-full flex flex-col bg-background-light">
        <Navbar />

        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/products" element={<Products />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/Industries" element={<Industries />} />
            <Route path="/Solutions" element={<Solutions />} />
            <Route path="/Technologies" element={<Technologies />} />
            <Route path="/request-demo" element={<RequestDemo />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/TermsConditions" element={<TermsConditions />} />
            

            // Routes for Product Pages

            <Route path="/Educationerp" element={<EducationERP />} />
            <Route path="/Hospitalerp" element={<HospitalERP />} />
            <Route path="/Inventoryerp" element={<Inventoryerp />} />
            <Route path="/HRMS" element={<HRMS />} />
            <Route path="/CRM" element={<CRM />} />
            <Route path="/Customerp" element={<Customerp />} />
            <Route path="/Financeerp" element={<FinanceERP />} />
            <Route path="/Manufacturingerp" element={<ManufacturingERP />} />
            <Route path="/Retailpos" element={<RetailPOS />} />
            <Route path="/Logisticserp" element={<LogisticsERP />} />
            <Route path="/Fooderp" element={<FoodERP />} />
            <Route path="/Hotelmanagement" element={<Hotelmanagement />} />

            // Routes for Services Pages

            <Route path="/DigitalTransformation" element={<DigitalTransformation />} />
            <Route path="/AiAutomation" element={<AiAutomation />} />
            <Route path="/ApiDevelopment" element={<ApiDevelopment />} />
            <Route path="/CloudSolutions" element={<CloudSolutions />} />
            <Route path="/SoftwareDevelopment" element={<SoftwareDevelopment />} />
            <Route path="/WebDevelopment" element={<WebDevelopment />} />
            <Route path="/MobileAppDevelopment" element={<MobileAppDevelopment />} />
            <Route path="/UiUxDesign" element={<UiUxDesign />} />

            // Routes for Solutions Pages

            <Route path="/BusinessOperations" element={<BusinessOperations />} />
            <Route path="/ManagementSystems" element={<ManagementSystems />} />
            <Route path="/CustomerEngagement" element={<CustomerEngagement />} />
            <Route path="/AiAutomationsolutions" element={<AiAutomationsolutions />} />

            //Routes for Industries Pages
            
            <Route path="/realestate" element={<RealEstate />} />
            <Route path="/construction" element={<Construction />} />
            <Route path="/pharmaceutical" element={<Pharmaceutical />} />
            <Route path="/automotive" element={<Automotive />} />
            <Route path="/energyutilities" element={<EnergyUtilities />} />
            <Route path="/mediaentertainment" element={<MediaEntertainment />} />
            <Route path="/agriculture" element={<Agriculture />} />
            <Route path="/government" element={<Government />} />
            <Route path="/ngo" element={<Ngo/>} />
            <Route path="/foodprocessing" element={<FoodProcessing />} />
            <Route path="/insurance" element={<Insurance />} />
            <Route path="/hospitality" element={<Hospitality />} />
            <Route path="/finance" element={<Finance />} />
            <Route path="/education" element={<Education />} />
            <Route path="/healthcare" element={<Healthcare />} />
            <Route path="/Manufacturing" element={<Manufacturing />} />
            <Route path="/Retail" element={<Retail />} />
            <Route path="/Logistics" element={<Logistics />} />

            // Routes for Other ways to reach out to us
{/* 
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/supportticket" element={<SupportTicket />} />
            <Route path="/livechat" element={<LiveChat />} />
            <Route path="/helpcenter" element={<HelpCenter />} />
             */}
            <Route
              path="*"
              element={<div className="p-20 text-center">404 - Page Not Found</div>}
            />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;